// extracted by mini-css-extract-plugin
export default {"list":"InlineBulletedList_list__Opw6i","listItem":"InlineBulletedList_listItem__ZFm4X","compact":"InlineBulletedList_compact__4z-kg"};